
(function() {
  'use strict';
  
  const SIZE_GUIDE_URL = '/pages/test-size';
  let customContent = null;
  let isLoaded = false;
  
  async function loadCustomContent() {
    if (isLoaded) return customContent;
    
    try {
      const response = await fetch(SIZE_GUIDE_URL);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const content = doc.querySelector('.rte') || doc.querySelector('.page-content') || doc.querySelector('main');
      
      if (content) {
        const wrapper = document.createElement('div');
        wrapper.className = 'custom-size-guide-content';
        const rteContent = content.querySelector('.rte');
        wrapper.innerHTML = rteContent ? rteContent.innerHTML : content.innerHTML;
        wrapper.querySelectorAll('script').forEach(s => s.remove());
        customContent = wrapper;
        isLoaded = true;
        return wrapper;
      }
    } catch (error) {
      console.error('Error:', error);
    }
    return null;
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadCustomContent);
  } else {
    loadCustomContent();
  }
  
  const observer = new MutationObserver(function() {
    const modal = document.querySelector('.scr-modal[style*="visible"]');
    if (modal) replaceContent(modal);
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style']
  });
  
  async function replaceContent(modal) {
    const modalBody = modal.querySelector('.scr.basic');
    if (!modalBody || modalBody.hasAttribute('data-replaced')) return;
    
    const content = await loadCustomContent();
    if (!content) return;
    
    modalBody.innerHTML = '';
    modalBody.appendChild(content.cloneNode(true));
    modalBody.setAttribute('data-replaced', 'true');
    
    addCustomStyles();
  }
  
  let stylesAdded = false;
  function addCustomStyles() {
    if (stylesAdded) return;
    
    const style = document.createElement('style');
    style.textContent = `
      .custom-size-guide-content { max-width: 100%; }
      
      .custom-size-guide-content table { width: 100%; border-collapse: collapse; margin: 20px 0; }
      .custom-size-guide-content table th, .custom-size-guide-content table td { border: 1px solid #ddd; padding: 12px 8px; }
      .custom-size-guide-content table th { background: #f5f5f5; font-weight: bold; }

     
      .custom-size-guide-content img { max-width: 100%; height: auto; margin: 20px auto; display: block; }
      .custom-size-guide-content hr { margin: 20px 0; border: none; border-top: 1px solid #ddd; }
      .scr-modal .scr.basic { max-height: 80vh; overflow-y: auto; }

      /* SABAL Size Guide — top sections only (match screenshot) */
.sg-wrap {
  --sg-text: #1a1a1a;
  --sg-muted: #5c5c5c;
  --sg-border: #d8d9dd;
  --sg-callout-bg: #f1f2f4;
  --sg-callout-border: #d8d9dd;
  --sg-pill-row-bg: #eeeff2;
  --sg-pill-inner-bg: #ffffff;
  --sg-pill-inner-border: #dadde2;
  --sg-table-header-bg: #e4e6ea;
  --sg-table-stripe-bg: #f5f6f8;
  color: var(--sg-text);
font-family: 'Montserrat';
  font-size: 16px;
  line-height: 1.55;
  max-width: 720px;
  margin: 0 auto;
  padding: 0 16px 2.5rem;
  text-align: left;
}
  table.custom-table {
    width: 100%;
}
.sg-wrap .sg-serif {
  font-family: Georgia, "Times New Roman", Times, serif;
}
.sg-hero {
  font-family: Georgia, "Times New Roman", Times, serif;
  font-size: 30px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin: 0 0 32px;
  line-height: 36px;
}
.sg-subhead {
font-family: 'Montserrat';
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 10px;
  line-height: 25px;
  color: var(--sg-text);
}
.sg-callout {
  background: #F7F1F0;
  border-radius: 10px;
  padding: 18px 10px;
  margin: 0 0 21px;
}
.sg-callout p {
  margin: 0 0 21px;
  font-size: 16px;
  line-height: 130%;
      font-weight: 400;
}
.sg-callout p:last-of-type { margin-bottom: 0; }
.sg-ibtc {
  font-family: Georgia, "Times New Roman", Times, serif;
  font-weight: 700;
  font-style: italic;
  margin-top: 0.85rem !important;
}
  p.sg-ibtc {
    font-weight: 700;
}
.sg-ibtc .sg-heart {
  color: #e85a7a;
  font-style: normal;
}
.sg-section-label {

  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0 0 10px;
  line-height: 130%;
}
.sg-means-list {
  margin: 0 0 1.5rem;
  padding: 0;
  list-style: none;
  font-size: 16px;
  line-height: 100%;
}
.sg-means-list li {
  margin: 0 0 0.85rem;
  padding: 0;
  position: relative;
  list-style: none;
}
.sg-means-list li:last-child { margin-bottom: 0; }
.sg-divider {
  border: none;
  border-top: 1px solid var(--sg-border);
  margin: 0 0 1.5rem;
}
h2.sg-sizing-title{
  font-family: Georgia, "Times New Roman", Times, serif;
  font-size: 30px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 1.5rem 0px 32px 0px;
  text-align: left;
}
.sg-sizing-lead {
  margin: 0 0 1rem;
  font-size: 16.5px;
}
.sg-sizing-prompt {
  font-family: Georgia, "Times New Roman", Times, serif;
  font-weight: 700;
  font-style: italic;
  margin: 0 0 10px;
  font-size: 16px;
}
.sg-pill-rows {
margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    width: auto;
  margin-bottom: 18px;
}
.sg-pill-row {
display: flex;
    align-items: center;
    gap: 10px;
    background: #F6F4EF;
    border-radius: 999px;
    padding: 5px 10px;
    margin: 0 0 0.65rem;
    font-size: 10px;
    font-weight: 300;
    width: fit-content;
}
.sg-pill-row:last-child { margin-bottom: 0; }
.sg-pill-row__left {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  min-width: 0;
  flex: 1;
}
.sg-check {
  color: #4a4a4a;
  font-weight: 600;
  flex-shrink: 0;
}
.sg-pill-row__label {
  color: var(--sg-text);
}
.sg-pill {
  display: inline-block;
  background: #FFFFFF;
  border-radius: 999px;
  padding: 7px 10px;
  font-size: 10px;
  font-weight: 300;
  color: var(--sg-text);
  flex-shrink: 0;
  line-height:normal;
}

h2.sg-tops-heading{
  font-family: Georgia, "Times New Roman", Times, serif;
  font-size: 26px;
  font-weight: 500;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0 0 31px;
  line-height: 1.35;
  color: var(--sg-text);
}

h2.sg-bottoms-heading {
    font-family: 'Montserrat';
    font-size: 26px;
    font-weight: 500;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin: 49px 0 1.25rem 0px !important;
    /* line-height: 1.35; */
    color: var(--sg-text);
    margin-top: 49px;
}
h2.sg-onepieces-heading {
    font-family: 'Montserrat';
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin: 0px;
    line-height: 1.35;
    color: var(--sg-text);
}
.sg-bottoms-section {
  margin: 0;
}
.sg-table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.sg-table-wrap--wide .sg-table {
  min-width: 520px;
}
.sg-wrap .sg-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.sg-wrap .sg-table thead th {
    background: #F8F8F8;
    border: 0px;
    padding: 10px 8px;
    text-align: left;
    font-weight: 700;
    text-transform: none;
    font-size: 16px;
    letter-spacing: 0.04em;
}

.sg-bottoms-section > p {
  margin: 0 0 0.65rem;
  font-size: 15px;
  line-height: 1.65;
}
  
table tr td, .scr.basic table tr th {
    background: #f6f6f6;
    border: 1px solid #eaeaea;
}

 table tr:nth-child(2) td {
    border-top: 1px solid #ddd;
}



.sg-bottoms-section .sg-top-style-title {
  margin-top: 1.15rem;
  text-transform: none;
  letter-spacing: 0.02em;
}
.sg-bottoms-section .sg-top-style-title:first-of-type {
  margin-top: 0;
}
.sg-measure-section {
  text-align: start;
  margin: 2.25rem 0 0;
}
.sg-measure-section h1 {
  font-family: Georgia, "Times New Roman", Times, serif;
  font-size: clamp(1.1rem, 3vw, 1.35rem);
  font-weight: 700;
  margin: 0 0 0.65rem;
  line-height: 1.3;
}
.sg-measure-section > p {
  margin: 0 0 0.75rem;
  font-size: 15px;
  line-height: 1.65;
}
.sg-measure-section ul {
  margin: 0;
  padding: 0 0 0 1.25rem;
  font-size: 15px;
  line-height: 1.65;
}
.sg-measure-section li {
  margin: 0 0 0.5rem;
}
.sg-measure-section li p {
  margin: 0;
}
.sg-diagram-figure {
  text-align: center;
  margin: 1.75rem 0 0;
}
.sg-diagram-figure img {
  margin: 10px;
  max-width: calc(100% - 20px);
  height: auto;
  vertical-align: middle;
}
.sg-onepiece-fit {
  margin: 1.25rem 0 0;
  font-size: 15px;
  line-height: 1.65;
}
.sg-onepiece-fit p {
  margin: 0;
}
.sg-chart-figure {
  margin: 0 0 1.25rem;
  text-align: center;
}
.sg-chart-figure img {
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  border-radius: 4px;
}
.sg-after-chart {
  margin-top: 0.5rem;
}
h2.sg-pro-tip-title{
    font-family: Georgia, "Times New Roman", Times, serif;
    font-size: 30px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin: 0 0 32px;
    line-height: 1.25;
    text-align:left;
}
  .text-wrapper {
    max-width: 400px;
    margin-left:40px;
}
.sg-pro-tip-lead {
  font-size: 15px;
  line-height: 1.6;
  margin: 0 0 1rem;
}
  p.sg-pro-tip-lead>span {
    font-family: 'EB Garamond';
    font-size: 16px;
    font-weight: 700;
}
.sg-pro-tip-callout {
    background: #F7F1F0;
    border-radius: 10px;
    padding: 1rem 1.15rem;
    margin: 0 0 2.5rem;
    font-weight: 400;
    line-height: 130%;
}
.sg-pro-tip-callout p {
  margin: 0;
  font-size: 15px;
  line-height: 130%;
}

.sg-fit-note-block > p:last-child {
  margin: 0;
  font-size: 15px;
  line-height: 1.65;
  margin-bottom:15px;
}
.sg-top-style-title {
    font-family: 'Montserrat';
    font-size: 18px;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin: 0 0 0.65rem;
}
.sg-top-style-list {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 15px;
  line-height: 1.65;
}
.sg-top-style-list li {
  margin: 0 0 0.4rem;
  padding-left: 0.15rem;
  list-style:none;
  margin-left: 30px;
}
.sg-top-style-list li:last-child {
  margin-bottom: 0;
}
.sg-style-section-hr {
  border: none;
  border-top: 1px solid var(--sg-border);
  margin: 1.75rem 0 1.25rem;
}

@media screen and (max-width: 769px) {
.sg-hero {
    font-size: 14px;
    line-height: 17px;
    margin: 0 0 15px;
}
    .sg-subhead {
    font-size: 8px;
    margin: 0 0 5px;
    line-height: 12px;

}
    .sg-callout {
    margin: 0 0 8px;
}
    .sg-callout p {
    margin: 0 0 7px;
    font-size: 8px;
    line-height: 130%;
    font-weight: 400;
}
    .sg-section-label {
    font-size: 8px;
    margin: 0 0 10px;

}
    .sg-means-list {
    margin: 0 0 1rem;
    font-size: 7px;
}
    .sg-means-list li {
  margin: 0 0 5px;
}
  .custom-size-guide-content hr {
    margin: 10px 0;
}
    h2.sg-sizing-title{
    font-size: 14px;
    line-height: 17px;
    margin: 0px;
    margin-bottom: 15px;
}
    p.sg-sizing-lead {
    font-size: 8px;
    line-height: 110%;
    margin: 0 0 5px;
}
li.sg-pill-row {
    font-size: 6px;
    gap: 5px;
    padding: 3px 5px;
    margin-bottom: 2px;
}
    span.sg-pill {
    font-size: 6px;
    padding: 3px;
}
    p.sg-sizing-prompt {
    font-size: 8px;
    line-height: 17px;
    margin: 0 0 5px;
}
    .sg-pill-rows {
    margin-bottom: 10px;
}
    h2.sg-tops-heading{
    font-size: 13px;
    line-height: 18px;
    margin: 0 0 9px;
}
    h2.sg-pro-tip-title {
    font-size: 14px;
    line-height: 18px;
    margin: 0 0 15px;
}
    .sg-chart-figure
 {
    margin: 0 0 0.5rem;
    text-align: center;
}
    .sg-pro-tip-lead {
    font-size: 8px;
    margin: 0 0 0.5rem;
}
    p.sg-pro-tip-lead>span {
    font-size: 8px;
}
    .sg-pro-tip-callout p {
    font-size: 8px;
}
    .sg-pro-tip-callout {
    padding: 8px 10px;
    margin: 0 0 2.5rem;
}
    .text-wrapper {
    margin-left: 20px;
}
    .sg-fit-note-block > p:last-child {
    font-size: 8px;
    line-height: 11px;
    margin-bottom: 4px;
}
    h3.sg-top-style-title {
    font-size: 9px;
    line-height: 10px;
    margin-top:10px;
}
    .sg-top-style-list {
    font-size: 8px;
    line-height: 11px;
}
    .sg-top-style-list li {
    margin-left: 10px;
}
    h2.sg-bottoms-heading {
    font-size: 11px;
    line-height: 14px;
    margin: 20px 0 10px 0px !important;
}
    .custom-size-guide-content table {
    margin: 5px 0px;
}
    .sg-bottoms-section > p {
    margin: 0 0 5px;
    font-size: 9px;
    line-height: 10px;
}
    h2.sg-onepieces-heading {
    font-size: 11px;
    line-height: 13px;
}
    .sg-onepiece-fit {
    font-size: 8px;
    line-height: 11px;
}


}
    `;
    document.head.appendChild(style);
    stylesAdded = true;
  }
})();
